import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import * as React from 'react'

export default { ContactPhoneIcon, React }